module.exports = __webpack_public_path__ + "static/media/apexchat.bea7b6d4.png";